// API configuration
// In development: uses localhost:3001 (Wrangler dev server)
// In production: uses relative URLs (Cloudflare Pages Functions)

const getApiUrl = (): string => {
  // Check if we're in development mode
  if (process.env.NODE_ENV === 'development') {
    // Use environment variable if set, otherwise default to localhost:3001
    return process.env.REACT_APP_API_URL || 'http://localhost:3001';
  }
  
  // In production, use relative URLs (Cloudflare Pages Functions handle /api/*)
  // Or use REACT_APP_API_URL if set (for custom deployments)
  return process.env.REACT_APP_API_URL || '';
};

export const API_BASE_URL = getApiUrl();

// Helper function to build API endpoint URLs
export const getApiEndpoint = (endpoint: string): string => {
  const baseUrl = API_BASE_URL;
  // Remove leading slash from endpoint if present
  const cleanEndpoint = endpoint.startsWith('/') ? endpoint.slice(1) : endpoint;
  
  if (baseUrl) {
    // If baseUrl exists, ensure it doesn't end with a slash
    const cleanBaseUrl = baseUrl.endsWith('/') ? baseUrl.slice(0, -1) : baseUrl;
    return `${cleanBaseUrl}/${cleanEndpoint}`;
  }
  
  // If no baseUrl, return endpoint with leading slash (relative URL)
  return `/${cleanEndpoint}`;
};

